import React, { useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { getQuestionsCountByDay } from "../../API/api";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label, Bar, BarChart, Cell } from 'recharts';
import moment from "moment";
import { IconButton, Typography } from "@mui/material";
import { Spin, Drawer, Row, Col } from "antd";
import VizHeader from "../VizHeader/VizHeader";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useCurrentPng, useGenerateImage } from "recharts-to-png";
import FileSaver, { saveAs } from "file-saver";
import { Tooltip as Tooltip2 } from '@mui/material'
import SelectComponentMonthsDuration from "../SelectMonthsDurationCMGraphs/SelectComponentMonthsDuration";
import { TitleAndDurationComponent } from "./TitleAndDurationComponent";
import { Dropdown } from "antd"
import { toJpeg } from "html-to-image";
import * as htmlToImage from 'html-to-image';
import SelectComp from "../../NewComponent/Select/Select";
import ChartToggleComponent from "../../NewComponent/ChartToggleComponent/ChartToggleComponent";
import { toggleChartRegionValues } from "../../utils";
import { ReactComponent as SettingIcon } from "./../../Icons/settings.svg";



export default function LineChartComponentForMultiple() {
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer)
	const overviewReducer = useSelector((state) => state.cmOverview)
	const userState = useSelector((state) => state.user);
	const cmRootReducer = useSelector(state => state.cmRoot);
	const [key, setKey] = React.useState('Global')
	const dispatch = useDispatch();
	const { getQuestionsCountByDayCount } = bindActionCreators(Actions, dispatch);
	const [loading, setLoading] = React.useState(false);
	const [selectedVal, setSelectedVal] = React.useState("Submitted");
	const [getData, setData] = React.useState([]);
	const [getKeys, setKeys] = React.useState([])
	const [getRegionKeys, setRegionKeys] = React.useState([])
	const [activeSIndex, setActiveIndex] = React.useState(-1);
	const [activeSeries, setActiveSeries] = React.useState(null);
	const [activeIndex, setActiveIndexIn] = React.useState(0);
	const [getTooltipPayload, setTooltipPayload] = React.useState([]);
	const [activeKeys, setActiveKeys] = React.useState(['Submitted',
		'Unanswered',
		'Answered',
		'Searched'])
	const [opacityRegion, setRegionOpacity] = React.useState({})
	const [activeBarIndex, setActiveBarIndex] = React.useState(null);
	const [activeChartType, setActiveChartType] = React.useState({ id: 1, type: 'line' });
	const [dropdownToggle, setDropdownToggle] = React.useState(false);
	const [selected, IsSelected] = React.useState(false)
	const dropdownRef = useRef(null);
	const selectRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (!dropdownRef.current) return;

			const isClickInsideDropdown = dropdownRef.current.contains(event.target);

			let isClickInsideSelectDropdown = false;
			let node = event.target;
			while (node) {
				if (node.classList && node.classList.contains('ant-select-dropdown')) {
					isClickInsideSelectDropdown = true;
					break;
				}
				node = node.parentNode;
			}

			if (!isClickInsideDropdown && !isClickInsideSelectDropdown) {
				setDropdownToggle(false);
			}
		};

		if (dropdownToggle) {
			document.addEventListener('mousedown', handleClickOutside);
		} else {
			document.removeEventListener('mousedown', handleClickOutside);
		}
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [dropdownToggle]);



	// useEffect(() => {
	// 	const handleClickOutside = (event) => {
	// 		if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
	// 			setDropdownToggle(false);
	// 		}
	// 	};

	// 	if (dropdownToggle) {
	// 		document.addEventListener('mousedown', handleClickOutside);
	// 	} else {
	// 		document.removeEventListener('mousedown', handleClickOutside);
	// 	}

	// 	// Cleanup on unmount
	// 	return () => {
	// 		document.removeEventListener('mousedown', handleClickOutside);
	// 	};
	// }, [dropdownToggle]);


	const handleLegendClick = (e) => {
		const { dataKey } = e;

		// Check if the dataKey is already active
		const isActive = activeKeys.includes(dataKey);

		// If active, remove it from activeKeys; if not active, add it
		setActiveKeys((prevActiveKeys) =>
			isActive ? prevActiveKeys.filter((key) => key !== dataKey) : [...prevActiveKeys, dataKey]
		);
	};

	const handleLegendClickRegion = (e) => {
		const { dataKey } = e;

		// Check if the dataKey is already active
		const isActive = getRegionKeys.includes(dataKey);

		// If active, remove it from activeKeys; if not active, add it
		setRegionKeys((prevActiveKeys) =>
			isActive ? prevActiveKeys.filter((key) => key !== dataKey) : [...prevActiveKeys, dataKey]
		);
	}

	// const [areaData] = React.useState(getLgData(100));
	const [getAreaPng, { ref: areaRef }] = useCurrentPng();
	const [getDivJpeg, { ref }] = useGenerateImage({
		quality: 0.8,
		type: 'image/jpeg',
	});
	const items = [
		{
			key: '2',
			label: (
				<div onClick={() => handleAreaDownload()}>
					Download as PNG Image
				</div>
			),
		},
		{
			key: '3',
			label: (
				<div onClick={() => downloadSvgAsJpeg()}>
					Download as JPEG Image
				</div>
			),
		},
		{
			key: '4',
			label: (
				<div onClick={() => handleDownloadSVG()}>
					Download as SVG Vector Image
				</div>
			)
		}
	];
	// const handleAreaDownload = React.useCallback(async () => {
	// 	const png = await getAreaPng();
	// 	console.log(png, 'check png')
	// 	if (png) {
	// 		FileSaver.saveAs(png, "area-chart.png");
	// 	}
	// }, [getAreaPng]);

	const handleAreaDownload = () => {
		htmlToImage.toJpeg(document.getElementsByClassName('recharts-wrapper')[0], { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
			.then(function (dataUrl) {
				var link = document.createElement('a');
				link.download = `question-volume-trend.png`
				link.href = dataUrl;
				link.click();
			});
	}


	const handleDownloadSVG = () => {
		const chartContainer = document.getElementsByClassName('recharts-wrapper')[0];
		const chartSvg = chartContainer.querySelector('svg');
		const chartXml = new XMLSerializer().serializeToString(chartSvg);
		const svgBlob = new Blob([chartXml], { type: 'image/svg+xml;charset=utf-8' });
		saveAs(svgBlob, 'chart.svg');
	};

	const handleDownloadJPEG = React.useCallback(async () => {
		const jpeg = await getDivJpeg();
		if (jpeg) {
			FileSaver.saveAs(jpeg, 'area-chart.jpeg');
		}
	}, [])

	function downloadSvgAsJpeg() {
		htmlToImage.toJpeg(document.getElementsByClassName('recharts-wrapper')[0], { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
			.then(function (dataUrl) {
				var link = document.createElement('a');
				link.download = 'question-volume-trend.jpeg';
				link.href = dataUrl;
				link.click();
			});

	}

	const handleMouseEnterRegion = (data, index, series) => {
		setActiveIndex(index);
		setActiveSeries(series);
	};

	const handleMouseLeaveRegion = () => {
		setActiveIndex(-1);
		setTooltipPayload([])
		// setActiveSeries(null);
	};

	const handleHover = useCallback((data, index) => {
		setActiveIndexIn(index);
		setTooltipPayload(data?.tooltipPayload);
	}, []);

	const activeItem = getData[activeIndex];

	useEffect(() => {
		if (cmRootReducer.selecetdRoutingValue !== "") {
			setLoading(true)
			getQuestionsCountByDay(expertOverview.duration.value, cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedGeoLevel.length === 0 ? "" : cmRootReducer.selectedGeoLevel.label, cmRootReducer.selectedDomainIds, overviewReducer.userTypeSelect.value).then((res) => {
				if (res === undefined) return;
				if (res.data.data !== undefined || res.data.success) {
					setLoading(false)
					// setData(res.data.data)
					// let key = cmRootReducer.selectedGeoLevel.label !== ''  ? cmRootReducer.selectedGeoLevel.label : 'Global';
					if (cmRootReducer.selecetdRoutingValue === 1) {
						setKey(cmRootReducer.selectedGeoLevel.label)
					}
					if (cmRootReducer.selecetdRoutingValue === 2) {
						const getUniqueCountries = (data) => {
							const uniqueCountrySet = new Set();
							data.forEach(dataObject => {
								Object.values(dataObject).forEach(dateData => {
									Object.keys(dateData).forEach(country => {
										uniqueCountrySet.add(country);
									});
								});
							});
							return Array.from(uniqueCountrySet);
						};
						const uniqueCountries = getUniqueCountries(res.data.data);
						setKeys(uniqueCountries);
						setRegionKeys(uniqueCountries)
						const obj = uniqueCountries.reduce((acc, key) => {
							acc[key] = 1;
							return acc;
						}, {});
						setRegionOpacity(obj)
						let submittedData = res.data.data[0];
						let unAnsweredData = res.data.data[1];
						let answeredData = res.data.data[2];
						let searchedData = res.data.data[3];
						let existedDates = Object.keys(submittedData).sort();
						let uniqueCountryNames = [...existedDates];
						// console.log(uniqueCountryNames, 'check country names')
						let countryNames = [...Object.values(submittedData), ...Object.values(unAnsweredData), Object.values(searchedData), ...Object.values(answeredData)]
						// let countryKeys =  countryNames[0].map((ob)=>Object.keys(ob));
						// console.log(getKeys, 'check country keys')
						// console.log(countryNames, 'check country names')
						const desiredData = (dates, sd, ud, ad, sdd) => {
							let newArr = [];
							dates.filter(obj => {
								// console.log(sd[obj], 'check check check')
								newArr.push(
									{
										name: obj,
										submittedData: sd[obj],
										unAnsweredData: ud[obj],
										answeredData: ad[obj],
										searchedData: sdd[obj],
										submittedCountryWise: sd[obj],
										unAnsweredCountryWise: ud[obj],
										answeredCountryWise: ad[obj],
										searchedCountryWise: sdd[obj],
									}
								);
							})
							totalDataCount(newArr);
						}
						const addArr = (arr) => {
							// arr
							let count = arr.reduce((a, b) => a + b, 0);
							return count;
						}
						const totalDataCount = (arr) => {
							arr.filter(obj => {
								let allCountries = [...Object.keys(obj.submittedData), ...Object.keys(obj.unAnsweredData), ...Object.keys(obj.answeredData), ...Object.keys(obj.searchedData)]
								let allCountriesUnique = [...new Set(allCountries)]
								// console.log(allCountriesUnique, 'check all countries unique')
								// // setKeys(allCountriesUnique)
								// console.log(getKeys, 'check get keys')
								allCountriesUnique.filter(country => {
									let submittedCount = obj.submittedData[country] === undefined ? 0 : obj.submittedData[country];
									let unAnsweredCount = obj.unAnsweredData[country] === undefined ? 0 : obj.unAnsweredData[country];
									let answeredCount = obj.answeredData[country] === undefined ? 0 : obj.answeredData[country];
									let searchedCount = obj.searchedData[country] === undefined ? 0 : obj.searchedData[country];
									obj[country] = submittedCount + unAnsweredCount + answeredCount + searchedCount;
								}
								)
								obj.amt = addArr(Object.values(obj.submittedData)) + addArr(Object.values(obj.unAnsweredData)) + addArr(Object.values(obj.answeredData)) + addArr(Object.values(obj.searchedData));
								obj.submitted = addArr(Object.values(obj.submittedData));
								obj.unanswered = addArr(Object.values(obj.unAnsweredData));
								obj.answered = addArr(Object.values(obj.answeredData));
								obj.searched = addArr(Object.values(obj.searchedData));
								obj.countries = allCountriesUnique;
								delete obj.submittedData;
								delete obj.unAnsweredData;
								delete obj.answeredData;
								delete obj.searchedData;
								return arr;
							})
							setData(arr);
							// console.log(arr, 'check array')
						}
						desiredData(existedDates, submittedData, unAnsweredData, answeredData, searchedData);
					}
					if (cmRootReducer.selecetdRoutingValue === 3) {
						setKey('Global')
					}
					function getValuesForGeoLevels(val) {
						if (cmRootReducer.selecetdRoutingValue === 1) {
							val = cmRootReducer.selectedGeoLevel.label
							return val;
						}
						if (cmRootReducer.selecetdRoutingValue === 3) {
							val = 'Global'
							return val;
						}
					}
					// let submittedQCount = Object.entries(res.data.data[0]).sort().map(([date, obj]) => ({ date, ...obj }))
					// let unansweredQCount = Object.entries(res.data.data[1]).sort().map(([date, obj]) => ({ date, ...obj }));
					// let answeredQCount = Object.entries(res.data.data[2]).sort().map(([date, obj]) => ({ date, ...obj }));
					// let searchedQCount = Object.entries(res.data.data[3]).sort().map(([date, obj]) => ({ date, ...obj }));

					/* Code for geolevel values */
					let submittedQCount = Object.entries(res.data.data[0]).sort().map(([date, obj]) => ({ date, ...obj, totalSubmitted: Object.values(obj).splice(1).reduce((a, b) => a + b, 0) }))
					let unansweredQCount = Object.entries(res.data.data[1]).sort().map(([date, obj]) => ({ date, ...obj, totalUnaswered: Object.values(obj).splice(1).reduce((a, b) => a + b, 0) }));
					let answeredQCount = Object.entries(res.data.data[2]).sort().map(([date, obj]) => ({ date, ...obj, totalAnswered: Object.values(obj).splice(1).reduce((a, b) => a + b, 0) }));
					let searchedQCount = Object.entries(res.data.data[3]).sort().map(([date, obj]) => ({ date, ...obj, totalSearched: Object.values(obj).splice(1).reduce((a, b) => a + b, 0) }));
					/* Code for geolevel values */

					let questionsCount = []
					// let newArray1 = submittedQCount.map((obj)=>{return {date:obj.date,...obj,totalSubmitted:Object.values(obj).slice(1).reduce((a,b)=>a+b,0)}})
					// console.log(newArray1,'check array')
					submittedQCount.map((obj, ind) => {
						// let innerArray1 = submittedQCount.map((ob, i) => { return ob.Global });
						// let innerArray2 = unansweredQCount.map((ob, i) => { return ob.Global });
						// let innerArray3 = answeredQCount.map((ob, i) => { return ob.Global });
						// let innerArray4 = searchedQCount.map((ob, i) => { return ob.Global });

						// let innerArray1 = submittedQCount.map((ob, i) => { return ob[key] });
						// let innerArray2 = unansweredQCount.map((ob, i) => { return ob[key] });
						// let innerArray3 = answeredQCount.map((ob, i) => { return ob[key] });
						// let innerArray4 = searchedQCount.map((ob, i) => { return ob[key] });

						let innerArray1 = submittedQCount.map((ob, i) => { return ob[getValuesForGeoLevels(ob.Global)] });
						let innerArray2 = unansweredQCount.map((ob, i) => { return ob[getValuesForGeoLevels(ob.Global)] });
						let innerArray3 = answeredQCount.map((ob, i) => { return ob[getValuesForGeoLevels(ob.Global)] });
						let innerArray4 = searchedQCount.map((ob, i) => { return ob[getValuesForGeoLevels(ob.Global)] });

						// let innerArray1 = submittedQCount.map((ob, i) => { return ob['totalSubmitted']})
						// let innerArray2 = unansweredQCount.map((ob, i) => { return ob['totalUnaswered'] });
						// let innerArray3 = answeredQCount.map((ob, i) => { return ob['totalAnswered'] });
						// let innerArray4 = searchedQCount.map((ob, i) => { return ob['totalSearched'] });
						let obj1 = { date: moment(obj.date).format('MMM DD,YYYY'), Submitted: innerArray1[ind], Unanswered: innerArray2[ind], Answered: innerArray3[ind], Searched: innerArray4[ind], ...obj }
						questionsCount.push(obj1)
					})
					getQuestionsCountByDayCount(questionsCount)
					// setData(questionsCount)
				}
			})
		}
	}, [expertOverview.duration.value, cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedGeoLevel.length !== 0 && cmRootReducer.selectedGeoLevel.label, overviewReducer.userTypeSelect.value])

	const renderLabelValue = (val) => {
		if (val === null) {
			return "Last 31 days (UTC Timezone)"
		}
		if (val === '3months') {
			return "Last 3 months"
		}
		if (val === '6months') {
			return "Last 6 months"
		}
		if (val === '12months') {
			return "Last 12 months"
		}
		if (val === '-1months') {
			return "Year-To-Date"
		}
	}

	const [opacity, setOpacity] = React.useState({
		Submitted: 1,
		Unanswered: 1,
		Answered: 1,
		Searched: 1
	});

	const handleMouseEnterRegionOpacity = (o) => {
		const { dataKey } = o;
		setRegionOpacity({ ...opacityRegion, [dataKey]: 0.2 });
		// console.log(opacityRegion, 'check opacity region on hover')
	}

	const handleMouseLeaveRegionOpacity = (o) => {
		const { dataKey } = o;
		setRegionOpacity({ ...opacityRegion, [dataKey]: 1 });
	}

	const COLORS = [
		'#009bff',
		'#00b8e6',
		'#b85cff',
		'#5e3bff',
		'#f4c900',
		'#ef7928',
		'#00c16e',
		"#7cb5ec",
		"#434348",
		"#90ed7d",
		"#f7a35c",
		"#8085e9",
		"#f15c80",
		"#e4d354",
		"#2b908f",
		"#f45b5b",
		"#91e8e1",
	];

	const CustomizedTooltip = ({ active, payload, label }) => {
		// console.log(payload, 'check payload')
		if (active && payload.length > 0) {
			return (
				<div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '5px', boxShadow: `0 3px 10px rgb(0 0 0 / 0.3)`, border: `1px solid ${getTooltipPayload.length > 0 && getTooltipPayload[0]?.fill}`, zIndex: 1000 }}>
					{getTooltipPayload.length === 0 && (
						<>
							<p className="label">{moment(label).format('MMM DD, YYYY')}</p>
							{/* <p className="label" style={{ fontWeight: 500 }}>Total:0</p>
							<p className="label" style={{ fontWeight: 500 }}>Submitted:0</p>
							<p className="label" style={{ fontWeight: 500 }}>Unanswered:0</p>
							<p className="label" style={{ fontWeight: 500 }}>Answered:0</p>
							<p className="label" style={{ fontWeight: 500 }}>Searched:0</p> */}
						</>
					)}
					<p className="label">{getTooltipPayload.length > 0 && getTooltipPayload.map((o, i) => {
						return (
							<>
								<p className="label">{moment(o.payload.name).format('MMM DD, YYYY')}</p>
								{o.payload.amt > 0 && <p className="label" style={{ fontWeight: 500 }}>Total:{" "}{o.payload.amt.toLocaleString()}</p>}
								{o.value > 0 && <p className="label" style={{ fontWeight: 500 }}>{o.dataKey}:{" "}{o.value.toLocaleString()}</p>}
								{o.payload.submittedCountryWise[`${o.dataKey}`] > 0 && <p className="label" style={{ fontWeight: 500 }}>Submitted:{" "}{o.payload.submittedCountryWise[`${o.dataKey}`].toLocaleString()}</p>}
								{o.payload.unAnsweredCountryWise[`${o.dataKey}`] > 0 && <p className="label" style={{ fontWeight: 500 }}>Unanswered:{" "}{o.payload.unAnsweredCountryWise[`${o.dataKey}`].toLocaleString()}</p>}
								{o.payload.answeredCountryWise[`${o.dataKey}`] > 0 && <p className="label" style={{ fontWeight: 500 }}>Answered:{" "}{o.payload.answeredCountryWise[`${o.dataKey}`].toLocaleString()}</p>}
								{o.payload.searchedCountryWise[`${o.dataKey}`] > 0 && <p className="label" style={{ fontWeight: 500 }}>Searched:{" "}{o.payload.searchedCountryWise[`${o.dataKey}`].toLocaleString()}</p>}
							</>
						)
					})}</p>
				</div>
			)
		}
	}

	const CustomTooltipForGlobalAndCountry = ({ active, payload, label }) => {
		if (active && payload && payload.length > 0) {
			return (
				<p className="custom-tooltip" style={{ backgroundColor: '#fff', border: '1px solid #ececec', padding: '7px' }}>
					{<p className="label" style={{ margin: '5px' }}>{moment(label).format('MMM DD, YYYY')}</p>}
					{payload.map((obj, ind) => {
						return (
							obj.value > 0 && <p className="label" key={ind} style={{ margin: '5px', fontWeight: 'bold', color: obj.color }}>{obj.dataKey}:{" "}{obj.value.toLocaleString()}</p>
						)
					})}
				</p>
			)
		}
		// if(active && payload.length > 0 && payload[0].value !== 0 && payload[1].value !== 0 && payload[2].value !==0 && payload[3].value !==0)
		// {
		// 	return null;
		// }
	}

	const handleBarMouseEnter = (index) => {
		// console.log(index, 'check index')
		setActiveBarIndex(index?.dataKey);
	};

	// Event handler to reset the active bar index when not hovering over a bar
	const handleBarMouseLeave = () => {
		setActiveBarIndex(null);
	};

	const onClickChangeChartType = (val) => {
		setActiveChartType(val)
		IsSelected(!selected)
	}

	const onClickDropdownToggle = () => {
		setDropdownToggle(!dropdownToggle)
	}

	const [open, setOpen] = React.useState(false);

	const showDrawer = () => {
		setOpen(true);
	};

	const onClose = () => {
		setOpen(false);
	};

	// console.log("dropdownRef", dropdownRef)

	return (
		<>
			<div style={{ position: 'relative', padding: '10px', backgroundColor: '#fff', borderRadius: '8px' }}>
				{/* Header */}
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>

					{/* <VizHeader type={4} isBold={true}>Question Volume Trend</VizHeader> */}
					<span style={{ width: "100%", display: "flex", justifyContent: "center" }}>
						<VizHeader type={4} isBold={true}>Question Volume Trend</VizHeader>
					</span>
					<div style={{ flex: 1 }} />

					<div style={{ textAlign: 'center' }}>

					</div>
					<div style={{ position: 'absolute', right: 0, top: 0, padding: '5px' }}>
						{/* <i
							onClick={() => setDropdownToggle(!dropdownToggle)}
							className="fa fa-gear"
							style={{ fontSize: '24px', cursor: 'pointer', color: '#2a364a' }}
						/> */}
						<SettingIcon style={{ fontSize: '24px', cursor: 'pointer', }} onClick={() => setDropdownToggle(!dropdownToggle)} />
					</div>
				</div>

				{/* Chart */}
				<Spin spinning={loading}>
					<ResponsiveContainer width="100%" height={450} >
						{(cmRootReducer.selecetdRoutingValue === 3 || cmRootReducer.selecetdRoutingValue === 1) && activeChartType.id === 1 && (
							<LineChart
								data={expertOverview.getQuestionsCount}
								// margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
								margin={{ top: 50, right: 30, left: 20, bottom: 5 }}
								ref={areaRef}
								height={320}
							>
								<CartesianGrid stroke="#ececec" vertical={false} />
								<XAxis
									angle={-45}
									dy={10}
									dx={2}
									interval="equidistantPreserveStart"
									fontSize={11}
									dataKey="date"
									tickFormatter={(value) => moment(value).format('MMM-DD')}
								>
									<Label fontSize={12} fontWeight="bold" dy={30} dx={7} value={renderLabelValue(expertOverview.duration.value)} />

								</XAxis>
								<YAxis fontSize={12} axisLine={false} tickLine={false} allowDecimals={false}>
									<Label angle={-90} fontWeight="bold" value="Questions" dx={-20} />
								</YAxis>
								<Tooltip
									wrapperStyle={{ fontSize: '12px', fontWeight: 'bold', pointerEvents: 'auto' }}
									cursor={false}
									content={<CustomTooltipForGlobalAndCountry />}
								/>
								<Legend
									wrapperStyle={{ fontSize: '12px', padding: '22px', fontWeight: 'bold', cursor: 'pointer', height: '10px', alignItems: "center", marginLeft: "25px" }}
									onMouseEnter={handleBarMouseEnter}
									onMouseLeave={handleBarMouseLeave}
									onClick={handleLegendClick}

								/>

								{['Submitted', 'Unanswered', 'Answered', 'Searched'].map((key, idx) => (
									<Line
										key={key}
										hide={!activeKeys.includes(key)}
										isAnimationActive={false}
										strokeWidth={key === 'Submitted' ? 2.5 : 1.5}
										dataKey={key}
										stroke={['#009bff', '#00b8e6', '#b85cff', '#ef7928'][idx]}
										dot={false}
										type="bumpX"
										wrapperStyle={{ height: "10rem" }}
										opacity={activeBarIndex === null || activeBarIndex === key ? 1 : 0.3}

									/>
								))}
							</LineChart>
						)}

						{activeChartType.id === 2 && (cmRootReducer.selecetdRoutingValue === 3 || cmRootReducer.selecetdRoutingValue === 1) && (
							<BarChart
								data={expertOverview.getQuestionsCount}
								margin={{ top: 5, right: 40, left: 30, bottom: 5 }}
								barCategoryGap="15%"
								barGap={1}
							>
								<CartesianGrid stroke="#ececec" vertical={false} />
								<XAxis
									angle={-45}
									dy={9}
									dx={5}
									interval="equidistantPreserveStart"
									fontSize={11}
									dataKey="date"
									tickFormatter={(value) => moment(value).format('MMM-DD')}
								>
									<Label fontSize={12} fontWeight="bold" dy={30} dx={7} value={renderLabelValue(expertOverview.duration.value)} />
								</XAxis>
								<YAxis fontSize={12} axisLine={false} tickLine={false} allowDecimals={false}>
									<Label angle={-90} fontWeight="bold" value="Questions" dx={-20} />
								</YAxis>
								<Tooltip
									wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }}
									cursor={false}
									content={<CustomTooltipForGlobalAndCountry />}
								/>
								<Legend
									wrapperStyle={{ fontSize: '12px', padding: '22px', fontWeight: 'bold', cursor: 'pointer', height: '10px', marginLeft: "25px" }}
									onClick={handleLegendClick}
									onMouseEnter={handleBarMouseEnter}
									onMouseLeave={handleBarMouseLeave}
								/>
								{['Submitted', 'Answered', 'Searched', 'Unanswered'].map((key, idx) => (
									<Bar
										key={key}
										hide={!activeKeys.includes(key)}
										dataKey={key}
										fill={['#009bff', '#b85cff', '#ef7928', '#00b8e6'][idx]}
										stackId="a"
										opacity={activeBarIndex === null || activeBarIndex === key ? 1 : 0.3}
									/>
								))}
							</BarChart>
						)}

						{cmRootReducer.selecetdRoutingValue === 2 && (
							<BarChart
								data={getData}
								margin={{ top: 5, right: 40, left: 30, bottom: 5 }}
								barCategoryGap="15%"
								barGap={1}
								ref={areaRef}
							>
								<CartesianGrid vertical={false} stroke="#ececec" />
								<XAxis
									angle={-45}
									dy={9}
									dx={5}
									interval="equidistantPreserveStart"
									fontSize={11}
									dataKey="name"
									tickFormatter={(value) => moment(value).format('MMM-DD')}
								>
									<Label fontSize={12} offset={0} fontWeight="bold" dy={30} dx={7} value={renderLabelValue(expertOverview.duration.value)} />
								</XAxis>
								<YAxis fontSize={12} axisLine={false} tickLine={false} allowDecimals={false}>
									<Label angle={-90} fontWeight="bold" value="Questions" dx={-20} />
								</YAxis>
								<Tooltip
									wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }}
									cursor={{ fill: 'transparent' }}
									content={<CustomizedTooltip />}
								/>
								<Legend
									wrapperStyle={{ fontSize: '12px', padding: '22px', fontWeight: 'bold', cursor: 'pointer', height: '20px', marginLeft: "25px" }}

									onClick={handleLegendClickRegion}
									onMouseEnter={handleBarMouseEnter}
									onMouseLeave={handleBarMouseLeave}
								/>
								{getKeys?.map((key, index) => (
									<Bar
										key={key}
										dataKey={key}
										fill={COLORS[index % COLORS.length]}
										stackId="a"
										hide={!getRegionKeys.includes(key)}
										opacity={activeBarIndex === null || activeBarIndex === key ? 1 : 0.2}
										onMouseOver={handleHover}
										onMouseOut={handleMouseLeaveRegion}
									/>
								))}
							</BarChart>
						)}

					</ResponsiveContainer>
				</Spin>

				{/* Floating Settings Panel */}
				{dropdownToggle && (
					<div
						ref={dropdownRef}
						style={{
							position: 'absolute',
							top: '50px',
							right: '10px',
							width: '240px',
							backgroundColor: '#fff',
							padding: '12px',
							border: '1px solid #ccc',
							borderRadius: '8px',
							boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
							zIndex: 10
						}}>
						<div style={{ textAlign: 'end' }}>
							<i
								onClick={() => setDropdownToggle(false)}
								className="fa fa-close"
								style={{ fontSize: '18px', cursor: 'pointer' }}
							/>
						</div>

						<div style={{ paddingBottom: '10px' }}>
							<div ref={selectRef}>
								<SelectComponentMonthsDuration />
							</div>
						</div>
						{toggleChartRegionValues(cmRootReducer.selecetdRoutingValue) && (
							<div style={{ textAlign: 'end', marginBottom: '10px' }}>
								<ChartToggleComponent
									selected={selected}
									value={activeChartType}
									onClickFunction={() => onClickChangeChartType({ id: 1, type: 'line' })}
									type="line"
									fontSize="24px"
									color="#5c667b"
									setterFunction={IsSelected}
								/>
								&nbsp;&nbsp;
								<ChartToggleComponent
									selected={selected}
									value={activeChartType}
									onClickFunction={() => onClickChangeChartType({ id: 2, type: 'bar' })}
									type="bar"
									fontSize="24px"
									color="#5c667b"
									setterFunction={IsSelected}
								/>
							</div>
						)}

						{['PNG', 'JPEG', 'SVG'].map((format, i) => {
							const handleClick = [handleAreaDownload, downloadSvgAsJpeg, handleDownloadSVG][i];
							return (
								<div key={format} style={{
									marginBottom: '10px',
									textAlign: 'end',
									color: '#5c667b',
									fontSize: '14px'
								}}>
									<span>Download {format}</span>{" "}
									<span onClick={handleClick} style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }}>
										<i className="fa fa-download" />
									</span>
								</div>
							);
						})}
					</div>
				)}
			</div>
		</>


	)
}